// Sistema central de enumeración de listas de personas para las grillas
// (titulares, inhumados, etc.). La estrategia de separación vive acá: cambiarla
// (solo coma, "y", tope + "N más", etc.) impacta todos los usos sin tocar cada grilla.
//
// Se usa enumeración natural en español porque los nombres de persona no tienen
// coma interna, así que la coma no genera ambigüedad:
//   []            -> ''
//   ['A']         -> 'A'
//   ['A','B']     -> 'A y B'
//   ['A','B','C'] -> 'A, B y C'
//
// Con la opción { max } (útil para listas que pueden crecer, p. ej. inhumados de un
// panteón) se muestran los primeros `max` y se resume el resto:
//   unirEnumeracionEs(['A','B','C','D','E'], { max: 3 }) -> 'A, B, C y 2 más'
export const unirEnumeracionEs = (items = [], { max } = {}) => {
    const arr = items.filter(Boolean);

    if (arr.length === 0) return '';
    if (arr.length === 1) return arr[0];

    if (max && arr.length > max) {
        const restantes = arr.length - max;
        return `${arr.slice(0, max).join(', ')} y ${restantes} más`;
    }

    return `${arr.slice(0, -1).join(', ')} y ${arr[arr.length - 1]}`;
};
